<template>
  <Button
    :loading="loading"
    loadingText="提交中..."
    type="danger"
    text="下一步"
    :disabled="isDisabled"
    class="nextStep"
    :click="preClick"
  />
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Button from './Button.vue';
import { Dialog } from 'vant';

export default {
  name: 'NextButton',
  data() {
    return {
      isDisabled: true,
      loading: false,
      productName: ''
    };
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  components: {
    Button,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    // 获取该产品所属服务银行名称
    getBankNameByProduct(productId) {
      this.$api.PublicPage.getBankNameByProduct({
        productId
      }).then((res) => {
        this.productName = res.data.productName || '';
      });
    },
    preClick() {
      if(this.publicPage?.submitInfoAll?.productId === 'SPDB-FPD') {
        Dialog.confirm({
          title: '产品须知',
          message: `${this.productName}由系统自动审批，全流程需本人办理。该业务除贷款利息及担保公司担保费外，无其他任何费用，也不会委托中介机构或个人代理向您收取费用，任何以帮您办理贷款为由，向您索要费用的行为均属欺骗。`,
          confirmButtonText: '阅读并知晓',
          messageAlign: 'left',
          cancelButtonText: '取消',
        }).then(() => {
          this.onSubmit();
        });
      } else {
        this.onSubmit();
      }
    },
    onSubmit() {
          this.updateState({
            tabActive: 2,
          });
          this.$toast.clear();
          this.isDisabled = false;
    },
  },
  watch: {
    // 监听store里productId
    'publicPage.submitInfoAll.productId': {
      handler(val,oldVal) {
        if(!oldVal&&oldVal!==val){
        this.getBankNameByProduct(val);
        }
      },
      deep: true,
      immediate: true,
    },
    'form.passThrough': {
      handler() {
        this.isDisabled = this.form.passThrough;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped></style>
